export default __webpack_public_path__ + "static/media/telegram-icon.671d4d67.svg";